import { extensionsRoutes } from '@/pages/Routes';
import { ToastPosition } from '@chakra-ui/react';

interface POSITION_OPTIONS {
  [pos: string]: ToastPosition;
}
const URL_WEB_HOST_BASE = process.env.REACT_APP_MIVA_WEB_HOST;

export const URL_MIVA_PROCTOR_TOOL = {
  HOME: `${URL_WEB_HOST_BASE}${extensionsRoutes.Home}`,
  LOGIN: `${URL_WEB_HOST_BASE}${extensionsRoutes.Login}`,
  LOGOUT: `${URL_WEB_HOST_BASE}${extensionsRoutes.Logout}`,
};

export const DURATION = {
  TOAST: 3000,
  TOAST_TRANSITION: 1000,
};

export const POSITION: POSITION_OPTIONS = {
  TOP_LEFT: 'top-left',
  TOP_RIGHT: 'top-right',
  BOTTOM_LEFT: 'bottom-left',
  BOTTOM_RIGHT: 'bottom-right',
};

export const DATE_TIME_FULL_FORMAT = 'yyyy-MM-dd HH:mm:ss';
